import { observer } from 'mobx-react-lite';
import React from 'react';
import styles from '../program-sheet.module.scss';

import Fade from '@smart-tv/components/fade/fade';
import ImageFilled from '@smart-tv/components/image-filled/image-filled';
import Typography from '@smart-tv/components/typography';
import testIds from '@smart-tv/e2e/shared/variables';
import { ContentType } from '@smart-tv/typings/content';

import { formatMaxCharsWords } from '../../../utils/formatter/format-max-chars-words';
import { rootStore } from '../_stores/store-root';
import { uiStore } from '../_stores/store-ui';

export const ProgramSheetHeader = observer(() => {
  const { sheet } = rootStore.sheetStore;
  const { toggles } = uiStore;
  const [isPortraitCoverLoaded, setIsPortraitCoverLoaded] = React.useState(false);

  const portraitCover = new Image();
  portraitCover.src = sheet.portraitCover;
  portraitCover.onload = () => {
    setIsPortraitCoverLoaded(true);
  };
  portraitCover.onerror = () => {
    setIsPortraitCoverLoaded(false);
  };

  return (
    <div className={styles['program-sheet-header']}>
      <Fade in={!toggles.focusEpisodes}>
        <div className={styles['program-sheet-header__title']}>
          {isPortraitCoverLoaded && sheet.contentType === ContentType.Movies && (
            <ImageFilled
              className={styles['program-sheet-header__title-image']}
              src={portraitCover.src}
              alt={sheet.title}
            />
          )}
          <Typography
            className={styles['program-sheet-header__title-text']}
            data-testid={testIds.programsheet.header}
            variant="h2"
          >
            {sheet.title
              ? formatMaxCharsWords({ type: 'CHARS', max: 90, input: sheet.title })
              : 'Ingen programtitel'}
          </Typography>
        </div>
      </Fade>
      
    </div>
  );
});

export default ProgramSheetHeader;
